module.exports = __webpack_public_path__ + "assets/aws.da9b363e.svg";